import { Fragment } from 'react';
import { Menu } from '@pocketlaw/tetris';
import { useField } from 'formik';
import { getDueDaysPresets } from './utils';
import { useOnChange } from '../hooks/useOnChange';
import { getDateByTimeBeforeDate } from '../utils';
export function MenuItems() {
    const { handleChange } = useOnChange();
    const [dueDateField] = useField('dueDate');
    const dueDate = new Date(dueDateField.value || '');
    const setDateBeforeDueDate = (timeBeforeDueDate) => {
        const date = getDateByTimeBeforeDate({ date: dueDate, timeBefore: timeBeforeDueDate });
        handleChange(date);
    };
    const dueDatePresets = getDueDaysPresets(dueDate);
    if (dueDatePresets.length === 0) {
        return null;
    }
    return (<Fragment>
      <Menu.Divider />
      {dueDatePresets.map((preset) => (<Menu.Item key={preset.date} onClick={() => setDateBeforeDueDate(preset.date)}>
          {preset.label}
        </Menu.Item>))}
    </Fragment>);
}
